document.addEventListener("DOMContentLoaded", function () {
  const gallery = document.querySelector(".product-gallery");
  const dots = document.querySelectorAll(".product-gallery-dots .dot");
  const galleryItems = document.querySelectorAll(".product-gallery-item");

  // Function to update active dot
  function updateActiveDot(index) {
    dots.forEach((dot, i) => {
      dot.classList.toggle("active", i === index);
    });
  }

  // Update active dot on scroll
  gallery.addEventListener("scroll", function () {
    const scrollPosition = gallery.scrollLeft;
    let activeIndex = 0;

    galleryItems.forEach((item, i) => {
      const itemLeft = item.offsetLeft;
      const itemRight = itemLeft + item.offsetWidth;

      if (scrollPosition >= itemLeft && scrollPosition < itemRight) {
        activeIndex = i;
      }
    });

    updateActiveDot(activeIndex);
  });

  // Update active dot on thumbnail click
  const thumbnails = document.querySelectorAll(".product-media-thumbnail");
  thumbnails.forEach((thumbnail, i) => {
    thumbnail.addEventListener("click", function () {
      updateActiveDot(i);
    });
  });

  // Initialize active dot
  updateActiveDot(0);
});
